import type { JSX } from 'react';

import { FontSizes } from '@calm-web/design-system';

import Image from '@/components/image/NextImage';
import { useGuideState, useProgramState } from '@/hooks/store/useAppState';

import {
	ContentDisplayWrapper,
	ContentImageWrapper,
	ContentTitle,
	ContentTypeNarratorNameContainer,
} from './styles';

function ContentDisplay(): JSX.Element {
	const guide = useGuideState();
	const program = useProgramState();
	const ogImage = program?.background_image ?? guide?.cell_image ?? program?.guides[0].cell_image;
	const contentNarrator = program?.narrator?.name || '';
	const contentName = program?.title || '';
	const contentImage = ogImage?.url || '';
	const contentType = program?.content_type || '';

	const imageRatio = ogImage?.width && ogImage?.height ? ogImage.width / ogImage.height : 1;

	return (
		<ContentDisplayWrapper>
			<ContentImageWrapper>
				{contentImage ? (
					<Image
						data-testid="sharePrimerContentImage"
						data-testsrc={contentImage}
						width={200}
						height={200 * imageRatio}
						src={contentImage}
						alt="Content Image"
						aria-label={'Content'}
					/>
				) : null}
			</ContentImageWrapper>
			<ContentTitle size={FontSizes.base} data-testid="sharePrimerContentName">
				<strong>{contentName}</strong>
			</ContentTitle>
			<ContentTypeNarratorNameContainer size={FontSizes.sm} color={'blackAlpha60'}>
				<span data-testid="sharePrimerContentType">{contentType}</span> &#8226;{' '}
				<span data-testid="sharePrimerContentNarrator">{contentNarrator}</span>
			</ContentTypeNarratorNameContainer>
		</ContentDisplayWrapper>
	);
}

export default ContentDisplay;
